import { ArrowBackRounded, AccountBalanceRounded } from "@mui/icons-material";
import { Box, Card, IconButton, Tab, Tabs, Typography } from "@mui/material";
import React, { PropsWithChildren, useEffect } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { greyEnabled, purple, purpleLight, black } from "../../theme/colors";


interface SchemeLayoutProps {
  page?:number
  setPage?: (page: number) => void;
}
export default function SchemeLayout({ children,setPage,page }: PropsWithChildren<SchemeLayoutProps>) {

  const [currentTab, setCurrentTab] = React.useState(0);
  const [searchParams, setSearchParams] = useSearchParams();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const handleChange = (event: React.SyntheticEvent, currentTabVal: number) => {
    setCurrentTab(currentTabVal);
    routeBasedOnTabChange(currentTabVal);
  };
  function routeBasedOnTabChange(currentTabVal: number) {
    if (currentTabVal === 0) {
      navigate("/schemes");
    } else if (currentTabVal === 1) {
      navigate("/schemes/enquiries");
    } else {
      navigate("/schemes/familyEnquiries");
    }
  }

  function tabChangeBasedOnRoute() {
    if (pathname === "/schemes/enquiries") {
      setCurrentTab(1);
    } else if (pathname === "/schemes") {
      setCurrentTab(0);
    } else {
      setCurrentTab(2);
    }
  }

  useEffect(() => {
    tabChangeBasedOnRoute();
  }, []);

  const handleBackClick = () => {
    const currPage = Number(searchParams.get("page")) || 1;

    if (currPage > 1) {
      const newPage = currPage - 1;
      setPage?.(newPage);
      setSearchParams(prev => {
        const params = new URLSearchParams(prev);
        params.set("page", (newPage + 1).toString());
        return params;
      }, { replace: true });

    }
  };

  return (
    <Box display={"flex"} mt={4}>
      <Card
        elevation={0}
        sx={{
          display: "flex",
          width: "100%",
          minHeight: 600,
          mb: 2,
          borderRadius: 3,
          border: "1px solid #ECECEC",
        }}
      >
        <Box display="flex" flexDirection={"column"} sx={{ width: "100%" }}>
          <Box
            sx={{
              borderBottom: "1px solid #ECECEC",
              p: { xs: 2.5, sm: 3 },
              pb: 0,
            }}
          >
            <Box display="flex" alignItems="center" gap={1}>
              {page !== undefined && page > 1 && (
                <IconButton onClick={handleBackClick}>
                  <ArrowBackRounded />
                </IconButton>
              )}
              <Box display="flex" alignItems="center" gap={1.5}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: 44,
                    height: 44,
                    borderRadius: 2,
                    bgcolor: purpleLight,
                    flexShrink: 0,
                  }}
                >
                  <AccountBalanceRounded sx={{ color: purple, fontSize: 24 }} />
                </Box>
                <Box>
                  <Typography variant="h5" fontWeight={700} color={black}>
                    Schemes
                  </Typography>
                  <Typography variant="body2" color={greyEnabled}>
                    Manage schemes, enquiries and family enquiries.
                  </Typography>
                </Box>
              </Box>
            </Box>
            <Tabs
              value={currentTab}
              aria-label="scheme tabs"
              onChange={handleChange}
              TabIndicatorProps={{
                style: { backgroundColor: purple, height: 3, borderRadius: 3 },
              }}
              sx={{ mt: 2 }}
            >
              <Tab
                label="Schemes"
                sx={{
                  textTransform: "none",
                  fontWeight: 600,
                  color: black,
                }}
              />
              <Tab
                label="Enquiries"
                sx={{
                  textTransform: "none",
                  fontWeight: 600,
                  color: black,
                }}
              />
              <Tab
                label="Family Enquiries"
                sx={{
                  textTransform: "none",
                  fontWeight: 600,
                  color: black,
                }}
              />
            </Tabs>
          </Box>
          {children}
        </Box>
      </Card>
    </Box>
  );
}
